import { render, staticRenderFns } from "./TouristCard.vue?vue&type=template&id=017a9a31&"
import script from "./TouristCard.vue?vue&type=script&lang=ts&"
export * from "./TouristCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports